import {Component} from '@angular/core';

@Component({
    selector: 'app-activation-notice',
    standalone: true,
    template: `
        <div class="activation-notice" role="status">
            <i class="pi pi-info-circle" aria-hidden="true"></i>
            <p>Tu cuenta está en modo de prueba. Contacta al administrador para activar la facturación electrónica con SUNAT.</p>
        </div>
    `,
    styles: [`
        :host { display: block; margin: 8px 0 1rem; }
        .activation-notice {
            display: flex;
            align-items: flex-start;
            gap: 10px;
            padding: 10px 12px;
            border-radius: 6px;
            background: var(--surface-section);
            color: var(--text-color);
            font-size: 13px;
            line-height: 1.5;
        }
        i { flex: 0 0 auto; margin-top: 2px; color: var(--primary-color); font-size: 16px; }
        p { margin: 0; }
    `]
})
export class AppActivationNoticeComponent {}
